<template>
  <div>
    <div style="margin-bottom:10px;">
      <Button type="primary" @click="openAddModal">新增角色</Button>
    </div>

    <Table :columns="columns" :data="list" border />

    <!-- 新增/编辑角色弹窗 -->
    <Modal v-model="modalVisible" :title="editMode ? '编辑角色' : '新增角色'" width="440" @on-cancel="resetForm">
      <Form :model="form" :rules="rules" ref="form" :label-width="90">
        <FormItem label="角色标识" prop="role_key">
          <Input v-model="form.role_key" placeholder="如：admin、jixiu" :disabled="editMode" />
        </FormItem>
        <FormItem label="角色名称" prop="role_name">
          <Input v-model="form.role_name" placeholder="如：管理员、机修" />
        </FormItem>
        <FormItem label="备注">
          <Input v-model="form.remark" placeholder="备注信息（可选）" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="resetForm">取消</Button>
        <Button type="primary" @click="submitForm">确认</Button>
      </div>
    </Modal>

    <!-- 配置菜单权限弹窗 -->
    <Modal v-model="menuModalVisible" title="配置菜单权限" width="500">
      <div style="max-height:400px;overflow-y:auto;">
        <Tree
          :data="menuTree"
          show-checkbox
          @on-check-change="onCheckChange"
          ref="menuTree"
        />
      </div>
      <div slot="footer">
        <Button @click="menuModalVisible=false">取消</Button>
        <Button type="primary" @click="saveMenus">保存权限</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getRoleList, addRole, updateRole, deleteRole, getRoleMenus, saveRoleMenus } from '@/api/sysmanage';
import { getMenuList } from '@/api/sysmanage';

export default {
  data() {
    return {
      list: [],
      menuTree: [],
      checkedMenuIds: [],
      currentRoleId: null,
      menuModalVisible: false,
      modalVisible: false,
      editMode: false,
      form: { id: null, role_key: '', role_name: '', remark: '' },
      rules: {
        role_key: [{ required: true, message: '角色标识不能为空', trigger: 'blur' }],
        role_name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
      },
      columns: [
        { title: 'ID', key: 'id', width: 70 },
        { title: '角色标识', key: 'role_key', width: 150 },
        { title: '角色名称', key: 'role_name', width: 150 },
        { title: '备注', key: 'remark' },
        {
          title: '操作', key: 'action', width: 260, align: 'center',
          render: (h, params) => h('div', [
            h('Button', { props: { type: 'primary', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openEditModal(params.row) } }, '编辑'),
            h('Button', { props: { type: 'success', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openMenuModal(params.row) } }, '配置菜单'),
            h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => this.handleDelete(params.row) } }, '删除'),
          ])
        }
      ]
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      getRoleList({}).then(res => { this.list = res.data || []; }).catch(() => {});
    },
    openAddModal() {
      this.editMode = false;
      this.form = { id: null, role_key: '', role_name: '', remark: '' };
      this.modalVisible = true;
    },
    openEditModal(row) {
      this.editMode = true;
      this.form = { id: row.id, role_key: row.role_key, role_name: row.role_name, remark: row.remark };
      this.modalVisible = true;
    },
    openMenuModal(row) {
      this.currentRoleId = row.id;
      getMenuList({}).then(res => {
        const allMenus = res.data || [];
        getRoleMenus({ role_id: row.id }).then(r2 => {
          // 后端返回字符串如 "1,2,3"，转成数字数组
          const menusStr = r2.data || '';
          const checkedIds = menusStr ? String(menusStr).split(',').map(id => parseInt(id)).filter(id => !isNaN(id)) : [];
          this.menuTree = this.buildTree(allMenus, checkedIds);
          this.checkedMenuIds = checkedIds;
          this.menuModalVisible = true;
        });
      }).catch(() => {});
    },
    buildTree(menus, checkedIds) {
      const map = {};
      menus.forEach(m => {
        map[m.id] = {
          id: m.id,
          title: m.menu_name,
          checked: checkedIds.includes(m.id),
          expand: true,
          children: []
        };
      });
      const roots = [];
      menus.forEach(m => {
        if (Number(m.parent_id) === 0 || !map[m.parent_id]) {
          roots.push(map[m.id]);
        } else {
          map[m.parent_id].children.push(map[m.id]);
        }
      });
      roots.forEach(r => { if (!r.children.length) delete r.children; });
      return roots;
    },
    onCheckChange(checkedNodes) {
      this.checkedMenuIds = checkedNodes.map(n => n.id);
    },
    saveMenus() {
      saveRoleMenus({ role_id: this.currentRoleId, menus: this.checkedMenuIds.join(',') }).then(() => {
        this.$Message.success('保存成功');
        this.menuModalVisible = false;
      }).catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const api = this.editMode ? updateRole : addRole;
        api(this.form).then(() => {
          this.$Message.success(this.editMode ? '编辑成功' : '新增成功');
          this.modalVisible = false;
          this.fetchList();
        }).catch(() => {});
      });
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定删除角色【${row.role_name}】？`,
        onOk: () => {
          deleteRole({ id: row.id }).then(() => {
            this.$Message.success('删除成功');
            this.fetchList();
          }).catch(() => {});
        }
      });
    },
    resetForm() { this.modalVisible = false; this.$refs.form && this.$refs.form.resetFields(); }
  }
};
</script>
